import React from 'react';
/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

export var TabContext = /*#__PURE__*/React.createContext({});